import { Link } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import Seo from "@/components/Seo";
import { SERVICES } from "@/lib/constants";

export default function Services() {
  return (
    <PublicLayout>
      <Seo title="Site Clean-Up Services | Site Cleanup" description="Vacant lot clean-up, pre-build site clean-up, builder waste removal, end-of-build tidy-up, land clearing and construction debris removal across Melbourne and Victoria." />
      <section className="bg-asphalt text-white py-20">
        <div className="rs-container">
          <span className="rs-eyebrow text-safety">Services</span>
          <h1 className="mt-3 text-5xl md:text-7xl uppercase max-w-3xl">Clean-up services we quote on.</h1>
          <p className="mt-4 max-w-2xl text-white/75">We take enquiries for a broad range of site clean-up jobs and match each one with a contractor suited to the location, waste type and timeline.</p>
        </div>
      </section>
      <section className="py-20">
        <div className="rs-container grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {SERVICES.map((s) => (
            <div key={s.slug} className="rs-card" data-testid={`service-${s.slug}`}>
              <span className="rs-eyebrow">Service</span>
              <h2 className="font-display text-2xl uppercase mt-2">{s.title}</h2>
              <p className="text-sm text-muted-foreground mt-2">{s.blurb}</p>
              <Link to="/request-quote" className="mt-4 inline-block text-safety font-semibold text-sm hover:underline underline-offset-4">Request a quote →</Link>
            </div>
          ))}
        </div>
      </section>
      <section className="py-16 bg-safety text-white">
        <div className="rs-container flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div>
            <h3 className="font-display uppercase text-3xl md:text-4xl">Not sure which service fits your site?</h3>
            <p className="text-white/90 mt-2">Send a few photos through the quote form — we'll assess and recommend.</p>
          </div>
          <Link to="/request-quote" className="bg-asphalt text-white px-8 py-4 font-semibold uppercase tracking-widest border-2 border-asphalt hover:bg-white hover:text-asphalt transition-colors">Get a quote</Link>
        </div>
      </section>
    </PublicLayout>
  );
}
